import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ExperiencesList from "@/pages/experiences/page";
import ExperienceDetail from "@/pages/experiences/detail/page";
import Farmers from "@/pages/farmers/page";
import FarmerDetail from "@/pages/farmers/detail/page";
import Farms from "@/pages/farms/page";
import FarmDetail from "@/pages/farms/detail/page";
import Konaseema from "@/pages/konaseema/page";
import Stories from "@/pages/stories/page";
import StoryDetail from "@/pages/stories/detail/page";
import ShareStory from "@/pages/share-story/page";
import Reviews from "@/pages/reviews/page";
import Contact from "@/pages/contact/page";
import Partner from "@/pages/partner/page";
import PlanTrip from "@/pages/plan-trip/page";
import TripPrint from "@/pages/plan-trip/print/page";
import Terms from "@/pages/terms/page";
import Privacy from "@/pages/privacy/page";
import AdminLayout from "@/pages/admin/layout/AdminLayout";
import AdminOverview from "@/pages/admin/dashboard/page";
import AdminBookings from "@/pages/admin/bookings/page";
import AdminCalendar from "@/pages/admin/calendar/page";
import AdminAvailability from "@/pages/admin/availability/page";
import AdminCheckIns from "@/pages/admin/check-ins/page";
import AdminFarmers from "@/pages/admin/farmers/page";
import AdminFarms from "@/pages/admin/farms/page";
import AdminFarmerApplications from "@/pages/admin/farmer-applications/page";
import AdminVerification from "@/pages/admin/verification/page";
import AdminTraining from "@/pages/admin/training/page";
import AdminSafetyAudits from "@/pages/admin/safety-audits/page";
import AdminFarmerSettlements from "@/pages/admin/farmer-settlements/page";
import AdminVisitors from "@/pages/admin/visitors/page";
import AdminReviews from "@/pages/admin/reviews/page";
import AdminExperiences from "@/pages/admin/experiences/page";
import AdminPackages from "@/pages/admin/packages/page";
import AdminActivities from "@/pages/admin/activities/page";
import AdminPricing from "@/pages/admin/pricing/page";
import AdminPayments from "@/pages/admin/payments/page";
import AdminRefunds from "@/pages/admin/refunds/page";
import AdminCoupons from "@/pages/admin/coupons/page";
import AdminWebsitePages from "@/pages/admin/website-pages/page";
import AdminBlog from "@/pages/admin/blog/page";
import AdminFarmerStories from "@/pages/admin/farmer-stories/page";
import AdminStorySubmissions from "@/pages/admin/story-submissions/page";
import AdminMediaLibrary from "@/pages/admin/media-library/page";
import AdminSupportTickets from "@/pages/admin/support-tickets/page";
import AdminHomepage from "@/pages/admin/homepage/page";
import AdminFaqs from "@/pages/admin/faqs/page";
import AdminTestimonials from "@/pages/admin/testimonials/page";
import AdminSeo from "@/pages/admin/seo/page";
import AdminRevenue from "@/pages/admin/revenue/page";
import AdminSettlements from "@/pages/admin/settlements/page";
import AdminCampaigns from "@/pages/admin/campaigns/page";
import AdminNotifications from "@/pages/admin/notifications/page";
import AdminEmail from "@/pages/admin/email/page";
import AdminSms from "@/pages/admin/sms/page";
import AdminWhatsapp from "@/pages/admin/whatsapp/page";
import AdminVisitorGroups from "@/pages/admin/visitor-groups/page";
import AdminComplaints from "@/pages/admin/complaints/page";
import AdminIncidents from "@/pages/admin/incidents/page";
import AdminSafety from "@/pages/admin/safety/page";
import AdminDocuments from "@/pages/admin/documents/page";
import AdminCompliance from "@/pages/admin/compliance/page";
import AdminUsers from "@/pages/admin/admin-users/page";
import AdminRoles from "@/pages/admin/roles-permissions/page";
import AdminAuditLogs from "@/pages/admin/audit-logs/page";
import AdminSystemSettings from "@/pages/admin/system-settings/page";
import AdminIntegrations from "@/pages/admin/integrations/page";
import AdminAnalytics from "@/pages/admin/reports/analytics/page";
import AdminBookingReports from "@/pages/admin/reports/booking-reports/page";
import AdminRevenueReports from "@/pages/admin/reports/revenue-reports/page";
import AdminFarmPerformanceReport from "@/pages/admin/reports/farm-performance/page";
import AdminCustomerReports from "@/pages/admin/reports/customer-reports/page";
import AdminMarketingReports from "@/pages/admin/reports/marketing-reports/page";
import AdminModulePlaceholder from "@/pages/admin/components/ModulePlaceholder";
import AdminLogin from "@/pages/admin/login/page";
import AdminKonaseemaTrip from "@/pages/admin/konaseema-trip/page";
import AdminHelp from "@/pages/admin/help/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/experiences",
    element: <ExperiencesList />,
  },
  {
    path: "/experiences/:slug",
    element: <ExperienceDetail />,
  },
  {
    path: "/farms",
    element: <Farms />,
  },
  {
    path: "/farms/:slug",
    element: <FarmDetail />,
  },
  {
    path: "/plan-your-trip",
    element: <PlanTrip />,
  },
  {
    path: "/plan-your-trip/print",
    element: <TripPrint />,
  },
  {
    path: "/farm-partner",
    element: <Partner />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/farmers",
    element: <Farmers />,
  },
  {
    path: "/farmers/:slug",
    element: <FarmerDetail />,
  },
  {
    path: "/konaseema",
    element: <Konaseema />,
  },
  {
    path: "/stories",
    element: <Stories />,
  },
  {
    path: "/stories/:slug",
    element: <StoryDetail />,
  },
  {
    path: "/share-your-story",
    element: <ShareStory />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminOverview />,
      },
      {
        path: "bookings",
        element: <AdminBookings />,
      },
      {
        path: "calendar",
        element: <AdminCalendar />,
      },
      {
        path: "availability",
        element: <AdminAvailability />,
      },
      {
        path: "check-ins",
        element: <AdminCheckIns />,
      },
      {
        path: "farmers",
        element: <AdminFarmers />,
      },
      {
        path: "farms",
        element: <AdminFarms />,
      },
      {
        path: "farmer-applications",
        element: <AdminFarmerApplications />,
      },
      {
        path: "verification",
        element: <AdminVerification />,
      },
      {
        path: "training",
        element: <AdminTraining />,
      },
      {
        path: "safety-audits",
        element: <AdminSafetyAudits />,
      },
      {
        path: "farmer-settlements",
        element: <AdminFarmerSettlements />,
      },
      {
        path: "visitors",
        element: <AdminVisitors />,
      },
      {
        path: "reviews",
        element: <AdminReviews />,
      },
      {
        path: "experiences",
        element: <AdminExperiences />,
      },
      {
        path: "packages",
        element: <AdminPackages />,
      },
      {
        path: "activities",
        element: <AdminActivities />,
      },
      {
        path: "pricing",
        element: <AdminPricing />,
      },
      {
        path: "payments",
        element: <AdminPayments />,
      },
      {
        path: "refunds",
        element: <AdminRefunds />,
      },
      {
        path: "coupons",
        element: <AdminCoupons />,
      },
      {
        path: "website-pages",
        element: <AdminWebsitePages />,
      },
      {
        path: "blog",
        element: <AdminBlog />,
      },
      {
        path: "farmer-stories",
        element: <AdminFarmerStories />,
      },
      {
        path: "story-submissions",
        element: <AdminStorySubmissions />,
      },
      {
        path: "media-library",
        element: <AdminMediaLibrary />,
      },
      {
        path: "support-tickets",
        element: <AdminSupportTickets />,
      },
      {
        path: "homepage",
        element: <AdminHomepage />,
      },
      {
        path: "konaseema-trip",
        element: <AdminKonaseemaTrip />,
      },
      {
        path: "help",
        element: <AdminHelp />,
      },
      {
        path: "faqs",
        element: <AdminFaqs />,
      },
      {
        path: "testimonials",
        element: <AdminTestimonials />,
      },
      {
        path: "seo",
        element: <AdminSeo />,
      },
      {
        path: "revenue",
        element: <AdminRevenue />,
      },
      {
        path: "settlements",
        element: <AdminSettlements />,
      },
      {
        path: "campaigns",
        element: <AdminCampaigns />,
      },
      {
        path: "notifications",
        element: <AdminNotifications />,
      },
      {
        path: "email",
        element: <AdminEmail />,
      },
      {
        path: "sms",
        element: <AdminSms />,
      },
      {
        path: "whatsapp",
        element: <AdminWhatsapp />,
      },
      {
        path: "visitor-groups",
        element: <AdminVisitorGroups />,
      },
      {
        path: "complaints",
        element: <AdminComplaints />,
      },
      {
        path: "incidents",
        element: <AdminIncidents />,
      },
      {
        path: "safety",
        element: <AdminSafety />,
      },
      {
        path: "documents",
        element: <AdminDocuments />,
      },
      {
        path: "compliance",
        element: <AdminCompliance />,
      },
      {
        path: "admin-users",
        element: <AdminUsers />,
      },
      {
        path: "roles-permissions",
        element: <AdminRoles />,
      },
      {
        path: "audit-logs",
        element: <AdminAuditLogs />,
      },
      {
        path: "system-settings",
        element: <AdminSystemSettings />,
      },
      {
        path: "integrations",
        element: <AdminIntegrations />,
      },
      {
        path: "analytics",
        element: <AdminAnalytics />,
      },
      {
        path: "booking-reports",
        element: <AdminBookingReports />,
      },
      {
        path: "revenue-reports",
        element: <AdminRevenueReports />,
      },
      {
        path: "farm-performance",
        element: <AdminFarmPerformanceReport />,
      },
      {
        path: "customer-reports",
        element: <AdminCustomerReports />,
      },
      {
        path: "marketing-reports",
        element: <AdminMarketingReports />,
      },
      {
        path: ":module",
        element: <AdminModulePlaceholder />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;